import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class EntityPaymentMethodQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  item_guid?: Optional<string> = Optional.empty();
  country_code?: Optional<string> = Optional.empty();
  payment_provider_code?: Optional<string> = Optional.empty();
  account_type?: Optional<string> = Optional.empty();
  account_number?: Optional<string> = Optional.empty();
  account_name?: Optional<string> = Optional.empty();
  swift_code?: Optional<string> = Optional.empty();
  namespace?: Optional<string> = Optional.empty();

  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
}

export class EntityPaymentMethodCriteriaModelQuery {
  query = '';

  constructor(criteria: EntityPaymentMethodQueryCriteriaClass) {
    if (!criteria) {
      return;
    }

    this.query += criteria.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += criteria.item_guid.filter(x => x !== '').map(x => '&item_guid=' + x).orElse('');
    this.query += criteria.country_code.filter(x => x !== '').map(x => '&country_code=' + x).orElse('');
    this.query += criteria.payment_provider_code.filter(x => x !== '').map(x => '&payment_provider_code=' + x).orElse('');
    this.query += criteria.account_type.filter(x => x !== '').map(x => '&account_type=' + x).orElse('');
    this.query += criteria.account_number.filter(x => x !== '').map(x => '&account_number=' + x).orElse('');
    this.query += criteria.account_name.filter(x => x !== '').map(x => '&account_name=' + x).orElse('');
    this.query += criteria.swift_code.filter(x => x !== '').map(x => '&swift_code=' + x).orElse('');
    this.query += criteria.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += criteria.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset;
    this.query += '&limit=' + criteria.limit;
  }
}
